import {useState, useEffect} from "react";
function useScreenHeight() {
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    useEffect(() => {
        function handleResize() {
            setScreenHeight(window.innerHeight);
        }
        window.addEventListener("resize", handleResize);
    }, []);
    return screenHeight;
};

export default useScreenHeight